// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1IQBv7E1mYtJJrmzledfBp {\n    margin-top: 16px;\n    text-align: right;\n}\n\n._1uGEO4-Lh8PvmkvrzdaNH0 + ._1uGEO4-Lh8PvmkvrzdaNH0 {\n    margin-left: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"confirmationFooter": "_1IQBv7E1mYtJJrmzledfBp",
	"confirmationButton": "_1uGEO4-Lh8PvmkvrzdaNH0"
};
module.exports = exports;
